var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',[_c('Avatar',{attrs:{"slot":"left","size":50,"src":_vm.image},slot:"left"}),_vm._v(" "+_vm._s(_vm.title)+" "),_c('Button',{attrs:{"slot":"right","flat":""},on:{"click":function($event){$event.stopPropagation();return _vm.selectRecipe.apply(null, arguments)}},slot:"right"},[_vm._v("Select")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }